// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__D+Wvt","link":"HeaderSimple_link__VINCA"};